











import { defineComponent, ref, useRouter } from '@nuxtjs/composition-api'
import { LoginFormFields } from '~/modules/customer/components/LoginModal/forms/types';
import { loginAvailableViews as availableViews } from '~/utils/constants/layout';
import LoginForm from '~/modules/customer/components/LoginModal/forms/LoginForm.vue';
import { DU_STORE_CODE } from '~/utils/constants/store';

export default defineComponent({
    props: {
        changeView: {
            type: Function,
            required: true
        }
    },
    components: {
        LoginForm
    },
    setup() {
        const routes = useRouter();
        const loginForm = ref<LoginFormFields>({
            email: '',
            password: '',
            realSubmit: 'BYPOST',
            RURL: process.client ? window.location.href : '',
            ERRURL: process.client ? window.location.href:'',
            SC: DU_STORE_CODE
        });
        return {
            loginForm,
            availableViews
        }
    },
})
